let TableCSS = `*{margin:0;padding:0}.my-table-content {
  border-collapse: collapse;
  /* margin: 25px 0; */
  background-color: white;
  min-width: 400px;
  font-size: 0.9rem;
  /* overflow: hidden; */
  width: 90%;
  align-self: center;
}
.my-table-Header {
  background-color: rgb(7, 128, 128);
  color: black;
  text-align: left;
  font-weight: bold;
}
.my-table-content th,
.my-table-content td {
  padding: 10px 10px;
  font-weight: bold;
  /* text-align: center; */
}
.my-table-content tfoot tr {
  text-align: center;
  font-weight: bold;
  border-bottom: 2px double black;
}
.my-table-content tr {
  border-bottom: 1px solid lightgray;
}
.my-table-content tbody tr:last-of-type {
  border-bottom: 10px solid teal;
}
.my-table-border {
  border-left: 1px solid lightgray;
  border-right: 1px solid lightgray;
}

.my-table-content-centen {
  text-align: center;
}
`;
let FlexCss = `
#PrintPage {
  padding: 10px 15px;
  height: 100%;
  flex-direction: column;
  background-color: white;
  
}
.myContainer {
  display: flex;
}

.PrintHeadTitle {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;

  background-color: teal;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid black;
  flex-wrap: wrap;
  align-self: center;
  width: 90%;
  color: black;
  align-items: center;
  text-align: center;
  
  /* padding-bottom: 5px; */
}
.PrintHeadTitle .title {
  width: 90%;
  line-height: 20px;
}

.printHearder2 {
  /* flex-direction: ; */
  /* margin-top: 10px; */
  /* padding: 5px 15px; */
  margin-top: 5px;
  background-color: teal;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid black;
  /* flex-wrap: wrap; */
  justify-content: space-between;
  width: 90%;
  align-self: center;
}
.PrintHeadTitle .Headerinfo {
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-bottom: 5px;
  color: black;
  justify-content: center;
  max-width: 50%;
  /* line-height: 18px; */
  padding-right: 10px;
  padding-left: 10px;
}
#clientInf {
  display: flex;
  flex-direction: row;
}
#clientInf .myTitle {
  /* font-weight: bold; */
  padding-right: 10px;
  flex-wrap: nowrap;
}
#clientInf .myContent {
  flex-wrap: wrap;
  font-weight: lighter;
  text-align: center;
}

.Headerinfo h3,
.Headerinfo h5 {
  line-height: 0.5cm;
  font-weight: bold;
}

.titleBar {
  display: flex;
  /* flex-direction: row-reverse; */
  justify-content: end;
  background-color: rgb(3, 3, 129);
  height: 40px;
  align-items: center;
  padding-right: 15px;
  width: 90%;
  align-self: center;
}
`;
TableCSS += FlexCss;
TableCSS += `@media print {
    tr,
    td,
    th {
      page-break-inside: avoid;
    }
    thead {
      display: table-header-group;
    }
    .d-print-none {
      visibility: hidden;
      display: none;
    }
    a {
      color: #000000;
    }
  }`;
module.exports = {
  TableCSS,
};
